module.exports = __webpack_public_path__ + "img/charging-SWEDEN-en.2f77197d.png";